<!--
	Copyright (c) 2017-present, flop! contributors
	SPDX-License-Identifier: AGPL-3.0-or-later
	https://framagit.org/flopedt/flopedt
-->

<script setup lang="ts">
import { useI18n } from 'vue-i18n'

import { SUPPORTED_LOCALES } from '@/i18n/messages.ts'
import { changeLocale } from '@/i18n/settings.ts'

import DropdownMenuCheckbox from '@uikit/menu/dropdown/DropdownMenuCheckbox.vue'
import DropdownSubmenu from '@uikit/menu/dropdown/DropdownSubmenu.vue'

import LanguageIcon from '~mingcute/map/earth_2_line.svg' // editor/translate_2_line

import languages from '@/i18n/languages.json'

const { locale } = useI18n()

async function updateLocale(loc: string) {
  await changeLocale(loc)

  // TODO: update remote preferences if logged in
}
</script>

<template>
  <DropdownSubmenu>
    <template #icon><LanguageIcon /></template>
    <span>{{ $t('header.language') }}</span>
    <template #items>
      <DropdownMenuCheckbox
        v-for="loc in SUPPORTED_LOCALES"
        :key="loc"
        :model-value="locale === loc"
        @select="updateLocale(loc)"
      >
        {{ languages[loc as keyof typeof languages] }}
      </DropdownMenuCheckbox>
    </template>
  </DropdownSubmenu>
</template>
